<template>
  <div class="notificationDetails warp">
    <div class="head">
      <router-link to="/message">
        <div class="mar-right-10">消息中心</div>
      </router-link>
      <div class='arrow'></div>
      <div class="mar-right-10">公告详情</div>
    </div>
    <div class="messageDetail" v-loading="loading">
      <h1>{{ detail.noticeTitle }}</h1>
      <div class="date">{{ detail.createTime }}</div>
      <el-divider />
      <div class="messageInfo" v-html="detail.noticeContent"></div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import {mapGetters, mapMutations} from 'vuex'
import {listSearchMixin} from '@/config/mixin'
import { userInfo } from '../../../store/getter'
export default {
  name: 'notificationDetails',
  mixins: [listSearchMixin],
  data () {
    return {
      detail: {},
      loading: false
    }
  },
  mounted () {
    this.getDetail()
  },
  computed: {
    ...mapGetters([
      'noticeId','userInfo'
    ])
  },
  watch: {
    noticeId: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getDetail()
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO'
    }),
    getDetail () {
      let self = this
      self.loading = true
      let params = {
        url: api.noticeDetails + `?noticeId=${this.$route.query.id}`,
        method: 'GET',
        data: {}
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          this.detail = res.data
          this.getUserInfo()
          self.loading = false
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 获取用户信息
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {
        
        if (res.code === "200") {
          self.setUserInfo(res.data);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.notificationDetails {
  .head {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    .arrow {
      background-image: url('../../../../static/image/xiangyou@2x.png');
      width: 5px;
      height: 10px;
      margin-right: 10px;
    }
  }
  .messageDetail {
    background: #FFFFFF;
    padding: 50px 0;
    min-height: 500px;
    h1 {
      font-size: 40px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      margin-bottom: 20px;
    }
    .date {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      text-align: center;
      margin-bottom: 25px;
    }
    .messageInfo {
      min-height: 500px;
      p {
        font-size: 14px;
        color: #666666;
      }
    }
    .messageInfo >>> img{ // 修改v-html渲染的样式
      max-width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/messageCenter/notificationDetails.vue